<template>
  <div class="recruit_container">
    <div class="recruit_section02">
      <div class="recruit_head">01. 근무조건</div>
      <div class="text_container">
        <div class="condition_details">
          <div class="detail_title">
            <span class="recruit_body_bold">근무요일</span>
          </div>
          <div class="vertical_line"></div>
          <div class="detail_content">
            <span class="recruit_body"> 월 - 금 (주 5일) </span>
          </div>
        </div>
        <div class="condition_details">
          <div class="detail_title">
            <span class="recruit_body_bold">근무시간</span>
          </div>
          <div class="vertical_line"></div>
          <div class="detail_content">
            <span class="recruit_body">
              09:30 - 18:00
              <span class="recruit_body_bold">(주 36.5 시간)</span>
            </span>
          </div>
        </div>
        <div class="condition_details">
          <div class="detail_title">
            <span class="recruit_body_bold">근무장소</span>
          </div>
          <div class="vertical_line"></div>
          <div class="detail_content">
            <div class="pc">
              <span class="recruit_body">
                서울특별시 영등포구 국제금융로2길 32, 여의도파이낸스타워<br />
                (지하철 여의도역 3번 출구 도보 5분)
              </span>
            </div>
            <div class="phone">
              <span class="recruit_body">
                서울특별시 영등포구 국제금융로2길 32, 여의도파이낸스타워<br />
                (지하철 여의도역 3번 출구 도보 5분)
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "section02",
};
</script>
